/* eslint-disable @typescript-eslint/no-explicit-any */
import { MoreOutlined } from "@ant-design/icons";
import { Button, Card, Col, Dropdown, Row, Tag } from "antd";

export default function Contracts(props: any) {
  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <Row gutter={[0, 12]} style={{ marginTop: 16 }}>
      {props.data?.map((x: any) => {
        return (
          <Col span={24}>
            <Card className="dealsCard">
              <div className="dealsInfo">
                <h4>{x.contractName}</h4>
                <p>
                  {x.startDate} - {x.endDate}
                </p>

                <div className="dealsTags">
                  {x.serviceLine?.map((y: { name: string; color: string }) => {
                    return <Tag className={y.color}>{y.name}</Tag>;
                  })}
                </div>
              </div>
              <div className="dealsRightWrapper">
                <div className="dealsInnerCard">
                  <Card className="dealsInnerCardItem">
                    <div className="innerLabel">Total amount</div>
                    <h4>${x.amount.toLocaleString()}</h4>
                  </Card>
                  <Card className="dealsInnerCardItem">
                    <div className="innerLabel">Projected GM</div>
                    <h4>{x.projectedGM}%</h4>
                  </Card>
                  <Card className="dealsInnerCardItem greenCard">
                    <div className="innerLabel">Status</div>
                    <Tag className="default_tag accepted_tag">{x.status}</Tag>
                    <img
                      src="/images/grey_filled_success.svg"
                      alt=""
                      style={{
                        position: "absolute",
                        top: "12px",
                        right: "12px",
                      }}
                    />
                  </Card>
                </div>

                <div className="dropdownDeals">
                  <Dropdown
                    menu={{ items }}
                    trigger={["click"]}
                    placement="bottomRight"
                    className="actionButton"
                  >
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onKeyDown={(e) => e.stopPropagation()}
                      style={{
                        padding: "6px",
                      }}
                      className="only_icon"
                      icon={<MoreOutlined />}
                    />
                  </Dropdown>
                </div>
              </div>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
